module.exports = __webpack_public_path__ + "img/conveyor-belt-boxes.383e8d7f.svg";